import React, {useEffect, useState, useRef} from 'react';
import {PageHeader, Button, Table, Space, Tabs, Tag} from 'antd';
import {groupMessage} from '@/api/customer';
import dayjs from 'dayjs';
import styles from '../../index.module.less';
import _ from 'lodash';

import MsgDetailModal from '@/page/customer/MsgPage/List/MsgDetailModal';
import {useAuthStore} from '@/context/auth';
import {EyeOutlined} from '@/icons';

const {TabPane} = Tabs;
const tabs = [
    // {name: '个人群发', key: 'singleCustomer'},
    {name: '企业群发-发送客户', key: 'singleSender'},
    {name: '企业群发-发送客户群', key: 'group'},
];

function MsgList() {
    const [authStore] = useAuthStore();
    const userId = _.get(authStore, 'user.extId');
    const modalRef = useRef();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [current, setCurrent] = useState(1);
    const [size, setSize] = useState(10);
    const [searchParam, setSearchParam] = useState({
        createType: 'singleSender',
        userId,
        current,
        size,
    });
    const [tabKey, setTabKey] = useState('singleSender');
    const [msgId, setMsgId] = useState(null);

    useEffect(() => {
        init();
    }, [tabKey]);

    function init(temp = null) {
        setLoading(true);
        groupMessage(temp || searchParam).then(res => {
            setData(res.data);
            setLoading(false);
        });
    }

    function changeTab(key) {
        setData([]);
        setCurrent(1);
        setSize(10);
        let temp = {createType: key, userId, current: 1, size: 10};
        setSearchParam(temp);
        setTabKey(key);
        init(temp);
    }

    function renderTabs() {
        return (
            <Tabs onChange={changeTab} className={styles.container}>
                {tabs.map((item, i) => (
                    <TabPane tab={item.name} key={item.key}>
                        <div key={i}>{renderTable()}</div>
                    </TabPane>
                ))}
            </Tabs>
        );
    }

    function showDetail(id, sender) {
        setMsgId(id);
        modalRef.current.open(sender);
    }

    function onShowSizeChange(current, pageSize) {
        setSize(pageSize);
        setCurrent(current);
        let temp = searchParam;
        temp.size = pageSize;
        temp.current = current;
        setSearchParam(temp);
        init(temp);
    }

    function onChange(pageNumber) {
        setCurrent(pageNumber);
        let temp = searchParam;
        temp.current = pageNumber;
        setSearchParam(searchParam);
        init();
    }

    const columns = [
        {
            title: '消息创建人',
            dataIndex: 'creatorName',
        },
        tabKey !== 'singleCustomer'
            ? {
                  title: '消息发送人',
                  dataIndex: 'sysUser',
                  render: (text, record) => {
                      const {sysUser} = record;
                      return sysUser == null ? '' : sysUser.name + '(' + sysUser.extId + ')';
                  },
              }
            : {},
        {
            title: '消息内容',
            dataIndex: 'content',
            render: content => (
                <>
                    {content ? (
                        <div className={styles.word}>
                            <Tag
                                color="blue"
                                style={{
                                    maxWidth: '400px',
                                    background: '#F7F9FC',
                                    border: '1px solid rgba(204, 211, 237,.1)',
                                }}
                            >
                                <a title={content} style={{color: '#152D85'}}>
                                    {content.length > 20 ? content.substr(0, 20) + '...' : content}
                                </a>
                            </Tag>
                        </div>
                    ) : (
                        <Tag style={{color: '#999999'}}>无文字内容</Tag>
                    )}
                </>
            ),
        },
        {
            title: '发布时间',
            dataIndex: 'createTime',
            render: createTime => dayjs(parseInt(createTime)).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
            title: '操作',
            dataIndex: 'action',
            render: (text, record) => (
                <Space>
                    <Button
                        style={{color: '#152D85'}}
                        type="text"
                        icon={<EyeOutlined />}
                        onClick={() => showDetail(record.id, record.sender)}
                    >
                        查看详情
                    </Button>
                </Space>
            ),
        },
    ];

    function renderTable() {
        return (
            <Table
                columns={columns}
                dataSource={data.records}
                rowKey={record => record.id}
                loading={loading}
                pagination={{
                    total: data.total,
                    showTotal: total => `共 ${total} 条记录`,
                    showSizeChanger: true,
                    onShowSizeChange: onShowSizeChange,
                    onChange: onChange,
                    current,
                    pageSize: size,
                }}
            />
        );
    }

    return (
        <div style={{overflowY: 'auto'}}>
            <PageHeader title={'消息群发记录'} />
            <div className={styles.tableContainer}>{renderTabs()}</div>
            <MsgDetailModal
                ref={modalRef}
                msgId={msgId}
                sendType={tabKey}
                userId={userId}
                height={600}
            />
        </div>
    );
}

export default MsgList;
